'use client';

import { useAuthContext } from '@/contexts/AuthContext';

// Re-export as useAuth so existing consumers don't need to change imports
export function useAuth() {
  return useAuthContext();
}
